var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimer = function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#timer_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FEFEFE",
    strokeLinejoin: "round",
    d: "M6.278 4.265a.5.5 0 0 0 .424-.495V2.665a.5.5 0 0 0-.5-.5H5.42V1.113h3.615v1.052h-.782a.5.5 0 0 0-.5.5V3.77a.5.5 0 0 0 .424.494 6.1 6.1 0 0 1 2.954 1.322.5.5 0 0 0 .671-.033l.8-.8.745.745-.861.86-.02.02a.5.5 0 0 0-.064.627 6.165 6.165 0 0 1-5.174 9.517 6.165 6.165 0 0 1-6.167-6.165 6.16 6.16 0 0 1 5.217-6.092Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#timer_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FEFEFE",
    d: "M6.91 6.168v4h3.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "timer_svg__a",
    width: 13.416,
    height: 16.492,
    x: 0.52,
    y: 0.572,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_24908_5211",
    stdDeviation: 0.021
  })), /*#__PURE__*/React.createElement("filter", {
    id: "timer_svg__b",
    width: 4.133,
    height: 4.633,
    x: 6.344,
    y: 6.101,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_24908_5211",
    stdDeviation: 0.033
  })))));
};
export default SvgTimer;